import React, { useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { useBoolean } from '@fluentui/react-hooks';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../../common/CommonFuctions';
import { Col, Form, Row } from 'react-bootstrap';
import ListPagination from "../../../../Templates/List/ListPagination";
import { useGetListGapRevisionDocuments } from '../../../../../hooks/services/sKPI/useOfGAP';
import { getListGapRevisionDocuments } from '../../../../../services/sKPI/gap.service';
import { __DocumentTypeKeys, __MessageTypes } from '../../../../../common/Dictionaries';
import { ConstrainMode, DetailsListLayoutMode, OverflowSet, SelectionMode, ShimmeredDetailsList, SpinnerSize, TooltipHost } from '@fluentui/react';
import { base64ToArrayBuffer, getKeyByValue, isNullUndefined, saveByteArray, showMessage } from '../../../../../common/Helpers';
import MessageBox from '../../../../Common/Message/MessageBox';
import { addTransversalDocument } from '../../../../../services/sBook/document.service';
import Loading from '../../../../Templates/Site/Loading';
import { FILE_MAX_SIZE } from '../../../../../configurations/application.config';
import { getDocumentsDownload } from '../../../../../services/sKPI/gap.service';
import { envBlobDocumentUpload, envDocumentGetUrl, envDocumentValidate } from '../../../../../services/Env/transversal.service';

const SidePanelDocuments = (props) => {
    const { t } = useTranslation();

    const fileUploadControl = useRef();
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [downloadInProgress, setDownloadInProgress] = useState(false);

    const inputParam_GapRevisionId = props.gapRevisionId !== null && props.gapRevisionId !== undefined ? props.gapRevisionId : null;
    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : false;
    const inputParam_IsPanelOpen = props.isPanelOpen !== null && props.isPanelOpen !== undefined ? props.isPanelOpen : false;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen !== null && props.setterIsPanelOpen !== undefined ? props.setterIsPanelOpen : null;

    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [selectedFile, setSelectedFile] = useState(null);
    const [documentLinkList, setDocumentLinkList] = useState(null);
    useGetListGapRevisionDocuments(inputParam_GapRevisionId, documentLinkList, setDocumentLinkList, inputParam_IsPanelOpen)

    const onHideDialog = (ev) => {
        ev.preventDefault();
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
        showMessage(setMessageConfig, false, null, null)
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        showMessage(setMessageConfig, false, null, null)
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return <div>
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    }

    const onCancelUpload = () => {
        setSelectedFile(null);
        fileUploadControl.current.value = "";
        showMessage(setMessageConfig, false, __MessageTypes.WARNING, '')
    }

    const handleFileInput = (e) => {
        // handle validations
        const file = !isNullUndefined(e.target) ? e.target.files[0] : e;
        let flag = false;
        if (file) {
            const maxSizeInMB = FILE_MAX_SIZE;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

            if (file.size > maxSizeInBytes) {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
                setSelectedFile(file);
            }
            else {
                flag = true;
                setSelectedFile(file);
            }
        }
        return flag;
    };

    const onDownloadDocumentsByIds = (documentList, fileName) => {
        setDownloadInProgress(true);
        getDocumentsDownload(documentList).then((response) => {
            saveByteArray(fileName, base64ToArrayBuffer(response.data.data));
            setDownloadInProgress(false);
        }).catch(() => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            setDownloadInProgress(false)
        });
    }

    const onUploadFile = async () => {
        //const ojbClientFormData = new FormData();
        //ojbClientFormData.append("file", selectedFile);
        //ojbClientFormData.append("id", inputParam_GapRevisionId);
        //ojbClientFormData.append("url", 'SkGAP/gaprevisiondocumentadd');
        if (!isNullUndefined(selectedFile)) {
            if (handleFileInput(selectedFile)) {
                showMessage(setMessageConfig, false, __MessageTypes.ERROR, '')
                setUploadInProgress(true);
                await envDocumentGetUrl('SkGAP/gaprevisiondocumentadd', inputParam_GapRevisionId, selectedFile.name).then(async (responseGetUrl) => {
                    if (responseGetUrl.data.succeeded === true) {
                        await envBlobDocumentUpload(responseGetUrl.data.data.url, responseGetUrl.data.data.fileName, selectedFile).then(async (responseAzure) => {
                            if (responseAzure.data === "" && responseAzure.status === 201) {
                                await envDocumentValidate(responseGetUrl.data.data.document_id).then(async (responseValidate) => {
                                    if (responseValidate.data.succeeded === true) {
                                        if (responseValidate.data.data.result_validate === true) {
                                            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                                            setDocumentLinkList(null);
                                            setSelectedFile(null);
                                            if (fileUploadControl.current) {
                                                fileUploadControl.current.value = '';
                                            }
                                            setUploadInProgress(false);
                                        }
                                        else {
                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.data.result_validate_msg))
                                            setUploadInProgress(false);
                                        }
                                    }
                                    else {
                                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.message))
                                        setUploadInProgress(false);
                                    }
                                })
                                .catch((error) => {
                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                    setUploadInProgress(false);
                                });
                            }
                            else {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setUploadInProgress(false);
                            }
                        })
                        .catch(async (error) => {
                            await envDocumentValidate(responseGetUrl.data.data.document_id, 0).then(async () => {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setUploadInProgress(false);
                            })
                            .catch((error) => {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                setUploadInProgress(false);
                            });
                        });
                    } else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseGetUrl.data.message))
                        setUploadInProgress(false);
                    }

                    setSelectedFile(null);
                    setUploadInProgress(false);
                })
                .catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setUploadInProgress(false);
                });
            }
            else {
                showMessage(inputParam_SetMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
            }
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectfile'))
        }
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-adddocument') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                {
                    inputParam_EditMode &&
                    <>
                        <Row>
                            <Col>
                                <div className='d-flex'>
                                    <TooltipHost content={
                                        <>
                                            <div>{'Tool TIP Archivos Permitidos: "7z", "doc", "docx", "eml", "jpeg", "jpg", "msg", "ods", "pdf", "png", "ppt", "pptx", "rar", "txt", "xls", "xlsb", "xlsx", "xps", "zip“. Peso: 80mb.'}</div>
                                            <div>{'Si tiene problemas con estos formatos, sugerimos guardar nuevamente el archivo con un programa estándar, ejemplo: Archivo de imagen “.jpg”  o “.png” utilizar abrir en “Paint” y volver a guardar.'}</div>
                                        </>
                                    }>
                                        <div className='d-flex align-items-center'>
                                            <Form.Control ref={fileUploadControl} type="file" size="sm" onChange={ handleFileInput } />
                                        </div>
                                    </TooltipHost>
                                    {
                                        !uploadInProgress &&
                                        <ActionButton id="btnUpload" iconProps={{ iconName: 'Upload' }} onClick={() => onUploadFile()} allowDisabledFocus disabled={selectedFile === null} >
                                            { t('data-lang-btn-upload') }
                                        </ActionButton>
                                    }
                                    {
                                        !uploadInProgress &&
                                        <ActionButton id="btnUpload" iconProps={{ iconName: 'RemoveFilter' }} onClick={() => onCancelUpload()} allowDisabledFocus disabled={selectedFile === null} >
                                            { t('data-lang-btn-cancel') }
                                        </ActionButton>
                                    }
                                    {
                                        uploadInProgress &&
                                        <Loading
                                                inputParam_ShowLoading={true}
                                                inputParam_ShowText={false}
                                                inputParam_Width={'35px'}
                                                inputParam_Height={'35px'}
                                                inputParam_Left={""}
                                                inputParam_Style={{marginTop: 0}}
                                                inputParam_ColClassName={"me-2"}
                                                inputParam_MarginLeft={"auto"}
                                                inputParam_SpinnerSize={SpinnerSize.medium} />
                                    }
                                </div>
                            </Col>
                        </Row>
                    </>
                }
                <Row>
                    <Col>
                        <ShimmeredDetailsList
                            className='list-no-filters'
                            enableShimmer={!documentLinkList}
                            items={documentLinkList || []}
                            columns={[
                                {  
                                    key: 'extension',
                                    name: t('data-lang-lbl-type'),
                                    fieldName: 'extension',
                                    maxWidth: 40,
                                    onRender:(item) => {
                                        return <>
                                            { getKeyByValue(__DocumentTypeKeys, item.extension) }
                                        </>
                                        
                                    }
                                },
                                {
                                    key: "documentCode",
                                    name: t('data-lang-lbl-code'),
                                    fieldName: "documentCode",
                                    maxWidth: 100,
                                    isResizable: true
                                },
                                {
                                    key: "name",
                                    name: t('data-lang-lbl-name'),
                                    fieldName: "name",
                                    maxWidth: 200,
                                    isResizable: true
                                },
                                {
                                    key: "creationUsername",
                                    name: t('data-lang-lbl-creationusername'),
                                    fieldName: "creationUsername",
                                    maxWidth: 100,
                                    isResizable: true
                                },  
                                {  
                                    key: 'id',
                                    name: t('data-lang-lbl-actions'),
                                    fieldName: 'id',
                                    //minWidth: "10%",
                                    //maxWidth: "10%",
                                    onRender:(item, row) => {
                                        return <div>
                                            {
                                                downloadInProgress &&
                                                    <Loading
                                                        inputParam_ShowLoading={true}
                                                        inputParam_ShowText={false}
                                                        inputParam_Width={'25px'}
                                                        inputParam_Height={'25px'}
                                                        inputParam_Left={""}
                                                        inputParam_Style={{marginTop: 0}}
                                                        inputParam_ColClassName={"me-2"}
                                                        inputParam_MarginLeft={"auto"}
                                                        inputParam_SpinnerSize={SpinnerSize.medium} />
                                            }
                                            {
                                                !downloadInProgress &&
                                                    <OverflowSet
                                                        className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                        role="menubar"
                                                        items={[
                                                            {
                                                                key: 'download',
                                                                icon: 'CloudDownload',
                                                                name: t('data-lang-btn-download'),
                                                                title: t('data-lang-btn-download'),
                                                                onClick: () => onDownloadDocumentsByIds([item.id], item.name),
                                                            }
                                                        ]}
                                                        onRenderOverflowButton={__onRenderOverflowButton}
                                                        onRenderItem={__onRenderOverflowItem}
                                                    />
                                            }
                                        </div>
                                    }
                                } 
                            ]}
                            getKey={(...args) => (args[0] ? args[0].key : args[1])}
                            setKey="multiple"
                            selectionMode={SelectionMode.none}
                            selectionPreservedOnEmptyClick={true}
                            layoutMode={DetailsListLayoutMode.fixedColumns}
                            constrainMode={ConstrainMode.unconstrained}
                            isHeaderVisible={true}
                            enterModalSelectionOnTouch={true}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col className="message-verybottom-panel-medium-pagination">
                        <ListPagination
                            listLocalStoragePageSizeVariableName="viewAllActions"
                            data={ documentLinkList }
                            setData={ setDocumentLinkList } />
                    </Col>
                </Row>
                <Row className="pt-3 mx-auto">
                    <Col className="message-verybottom-panel-medium">
                        <MessageBox 
                            inputParam_Width="96%" 
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                </Row>  
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
}

export default SidePanelDocuments;